import React, { useState, useEffect } from 'react';
import axios from 'axios';
import { useParams } from 'react-router-dom';
import './SegmAnnoLabelEdit.css';

const SegmAnnoLabelEdit = () => {
  const { id } = useParams();
  const token = localStorage.getItem('token');

  const [foreignPrefilled, setForeignPrefilled] = useState(false);
  const [formData, setFormData] = useState({
    foreign_key_content_type: '',
    foreign_key_object_id: '',
    file_path: '',
    frame_index: '',
    datasets: '',
    annotator: '',
    cardiac_phase: 'RANDOM',
  });
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState('');
  const [success, setSuccess] = useState(false);

  // Fetch existing label data
  useEffect(() => {
    axios
      .get(`${process.env.REACT_APP_BACKEND_URL}/patients/segm_anno_labels/${id}/`, {
        headers: { Authorization: `Token ${token}` },
      })
      .then((res) => {
        const label = res.data;
        setFormData({
          foreign_key_content_type: label.foreign_key.modality,
          foreign_key_object_id: label.foreign_key.id,
          file_path: label.file_path,
          frame_index: label.frame_index,
          datasets: label.datasets ? label.datasets.join(', ') : '',
          annotator: label.annotator,
          cardiac_phase: label.cardiac_phase || 'RANDOM',
        });
        setForeignPrefilled(true);
        setLoading(false);
      })
      .catch((err) => {
        console.error(err);
        setError('Error fetching SegmAnno label for editing.');
        setLoading(false);
      });
  }, [id, token]);

  // Handle form input changes
  const handleChange = (e) => {
    setFormData({ ...formData, [e.target.name]: e.target.value });
  };

  // Submit the edited data
  const handleSubmit = async (e) => {
    e.preventDefault();

    // Prepare payload similar to the create form
    const payload = {
      foreign_key: {
        modality: formData.foreign_key_content_type,
        id: parseInt(formData.foreign_key_object_id, 10),
      },
      file_path: formData.file_path,
      frame_index: parseInt(formData.frame_index, 10),
      datasets: formData.datasets
        ? formData.datasets.split(',').map((dataset) => dataset.trim())
        : [],
      annotator: formData.annotator,
      cardiac_phase: formData.cardiac_phase,
    };

    try {
      await axios.put(
        `${process.env.REACT_APP_BACKEND_URL}/patients/segm_anno_labels/${id}/edit/`,
        payload,
        { headers: { Authorization: `Token ${token}` } }
      );
      setSuccess(true);
      setError('');
    } catch (err) {
      console.error(err);
      setError('Error updating SegmAnno label. Please try again.');
      setSuccess(false);
    }
  };

  if (loading) return <p>Loading SegmAnno Label...</p>;
  if (error && !success) return <p className="error-message">{error}</p>;

  return (
    <div className="segm-anno-label-edit-container">
      <h3>Edit SegmAnno Label</h3>
      {error && <p className="error-message">{error}</p>}
      {success && <p className="success-message">SegmAnno Label updated successfully!</p>}

      <form onSubmit={handleSubmit} className="segm-anno-label-edit-form">
        <div className="form-group">
          <label>Content Type <span className="required-asterisk">*</span></label>
          <input
            type="text"
            name="foreign_key_content_type"
            value={formData.foreign_key_content_type}
            onChange={handleChange}
            required
            disabled={foreignPrefilled}
          />
        </div>
        <div className="form-group">
          <label>Object ID <span className="required-asterisk">*</span></label>
          <input
            type="text"
            name="foreign_key_object_id"
            value={formData.foreign_key_object_id}
            onChange={handleChange}
            required
            disabled={foreignPrefilled}
          />
        </div>
        <div className="form-group">
          <label>File Path <span className="required-asterisk">*</span></label>
          <input
            type="text"
            name="file_path"
            value={formData.file_path}
            onChange={handleChange}
            required
          />
        </div>
        <div className="form-group">
          <label>Frame Index <span className="required-asterisk">*</span></label>
          <input
            type="number"
            name="frame_index"
            value={formData.frame_index}
            onChange={handleChange}
            required
            min="1"
          />
        </div>
        <div className="form-group">
          <label>Datasets</label>
          <input
            type="text"
            name="datasets"
            value={formData.datasets}
            onChange={handleChange}
            placeholder="Comma separated datasets, e.g. 'dataset1, dataset2'"
          />
        </div>
        <div className="form-group">
          <label>Annotator <span className="required-asterisk">*</span></label>
          <input
            type="text"
            name="annotator"
            value={formData.annotator}
            onChange={handleChange}
            required
          />
        </div>
        <div className="form-group">
          <label>Cardiac Phase</label>
          <select
            name="cardiac_phase"
            value={formData.cardiac_phase}
            onChange={handleChange}
          >
            <option value="RANDOM">Random</option>
            <option value="SYSTOLE">Systole</option>
            <option value="DIASTOLE">Diastole</option>
          </select>
        </div>
        
        <button type="submit" className="segm-anno-label-edit-btn">
          Update SegmAnno Label
        </button>
      </form>
    </div>
  );
};

export default SegmAnnoLabelEdit;
